import { useState } from "react";

const useBackInStock = (variantId, callback) => {
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const { email } = form.elements;
    const userEmail = email.value;

    try {
      const response = await fetch("/.netlify/functions/back-in-stock", {
        method: "POST",
        body: JSON.stringify({
          accountId: process.env.GATSBY_KLAVIYO_COMPANY_ID,
          email: userEmail,
          variant: variantId,
          platform: "shopify"
        })
      });

      if (response.ok) {
        setSuccess(true);
        if (typeof callback === "function") {
          callback(userEmail);
        }
      } else {
        console.error("Error:", response.status);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return {
    handleSubmit,
    success
  };
};

export default useBackInStock;